import { Component, OnInit } from "@angular/core";
import { ActivationStart, Router } from "@angular/router";
import { PrimeNGConfig, Translation } from "primeng/api";
import { environment } from "src/environments/environment";
import { IdentityService } from "./auth/identity.service";
import { SignalrService } from "./core/signalr.service";

@Component({
  selector: "app-root",
  template: `
    <app-layout
      [layoutMode]="layoutMode"
      [userFullname]="identityService.userName"
      [userLogin]="identityService.userLogin"
      *ngIf="!isStandalone"
    >
      <router-outlet></router-outlet>
      <ng-template layoutTemplate="logo">
        <h1 style="color: white; margin-top: 0;">GASS</h1>
      </ng-template>
      <ng-template layoutTemplate="profileMenu">
        <app-profile-menu-show-permission></app-profile-menu-show-permission>
      </ng-template>
      <ng-template layoutTemplate="topbarItems">
        <div style="display: flex; justify-content: flex-end; gap: 0.5rem;">
          <app-topbar-search></app-topbar-search>
        </div>
      </ng-template>
    </app-layout>
    <router-outlet *ngIf="isStandalone"></router-outlet>
    <!-- Dialog with 2 buttons -->
    <p-confirmDialog
      [closable]="false"
      rejectButtonStyleClass="p-button-secondary"
      acceptLabel="Si"
      icon="pi pi-exclamation-triangle"
      rejectLabel="No"
      acceptIcon="pi pi-check"
      rejectIcon="pi pi-times"
    >
    </p-confirmDialog>
  `,
})
export class AppComponent implements OnInit {
  public layoutMode = window.innerWidth > 1080 ? 0 : 2;
  public isStandalone = false;

  constructor(
    public identityService: IdentityService,
    private readonly router: Router,
    private readonly primeng: PrimeNGConfig,
    public signalRService: SignalrService,
  ) {}

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof ActivationStart) {
        this.isStandalone = !!event.snapshot.data.standalone;
      }
    });

    this.signalRService.startConnection();
    this.signalRService.updateAllegatiListListener();
    this.primeng.setTranslation(environment.calendarLocale as Translation);
  }
}
